import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import { Trash } from "react-feather";

import { MySpinner } from "components/MySpinner";
import { getNewCrossByBrand } from "services/api";
import { Cut } from "components/Cut";
import { TableButton } from "components/TableButton";
import { Card, CardBody } from "reactstrap";
import { Pagination } from "components/Pagination";

export const Cross = ({
  activeTab,
  brand
}) => {
  const [loading, setLoading] = useState(false);
  const [cross, setCross] = useState([]);
  const [crossCount, setCrossCount] = useState(0);
  const [selected, setSelected] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const getAndSetCross = () => {
    if (!brand) return;
    setLoading(true);
    getNewCrossByBrand({
      "pagination[count]": pageSize,
      "pagination[offset]": (currentPage - 1) * pageSize,
      brandId: brand?.id,
    })
      .then((res) => {
        setCross(res.items || []);
        setCrossCount(res.totalItems || 0);
      })
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (activeTab === "2") {
      getAndSetCross();
    }
  }, [activeTab]);

  useEffect(() => {
    setLoading(true);
    getAndSetCross();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageSize]);

  const removeCrossHandler = () => { }

  const tableCrossColumns = [
    {
      dataField: "brand",
      text: "Бренд",
      formatter: (cell, row) => cell?.name,
      headerStyle: (colum, colIndex) => {
        return { width: "25%" };
      },
      editable: false,
      footer: () => null,
    },
    {
      dataField: "article",
      text: "Артикул",
      formatter: (cell, row) => {
        return row.nomenclatureId ? (
          <Link
            to={`/reference/nomenclature?search=${cell}`}
            target="_blank"
          >
            {cell}
          </Link>
        ) : (
          <>{cell}</>
        )
      },
      headerStyle: (colum, colIndex) => {
        return { width: "25%" };
      },
      editable: false,
      footer: () => null,
    },
    {
      dataField: "name",
      text: "Наименование",
      formatter: (cell, row) => <Cut>{cell}</Cut>,
      headerStyle: (colum, colIndex) => {
        return { width: "40%" };
      },
      editable: false,
      footer: () => null,
    },
    {
      dataField: "remove",
      text: "",
      formatter: (cell, row) => <TableButton
        Icon={Trash}
        onClick={() => removeCrossHandler(row.id)}
      />,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      editable: false,
      footer: () => null,
    },
  ];

  const selectRow = {
    mode: "checkbox",
    bgColor: "#bfbfbf",
    onSelect: (row, isSelect, rowIndex, e) => {
      setSelected((prev) => {
        if (!isSelect) {
          prev.splice(
            prev.findIndex((val) => val === row.id),
            1
          );
          return [...prev];
        }
        return [...prev, row.id];
      });
    },
    onSelectAll: (isSelect, rows, e) => {
      if (!isSelect) {
        setSelected([]);
      } else {
        setSelected(cross.map((val) => val.id));
      }
    },
  };

  const rowEvents = {
    onClick: (e, row) => {
      window.open(`/reference/cross/new?search=${row.article}&brand=${brand?.id}&brandName=${brand?.name}`, "_blank");
    },
  }

  return (
    <div className="mb-3">
      {loading && <MySpinner overlay />}

      <BootstrapTable
        wrapperClasses="cross p-0"
        keyField="id"
        data={cross}
        hover={true}
        columns={tableCrossColumns}
        bootstrap4
        bordered={false}
        selectRow={selectRow}
        rowEvents={rowEvents}
        classes="pointer"
      />

      <Card>
        <CardBody>
          <Pagination
            totalCount={crossCount}
            currentPage={currentPage}
            pageSize={pageSize}
            setCurrentPage={setCurrentPage}
            onChangePageSize={setPageSize}
          />
        </CardBody>
      </Card>
    </div>
  )
}